import axios from 'axios';
import { getApiUrl } from './apiConfig';

const axiosInstance = axios.create({
  baseURL: getApiUrl() || undefined,
  withCredentials: true, // Habilita el envío de cookies si es necesario
});

axiosInstance.interceptors.response.use(
  (response) => {
    const url = response.config?.url || '';
    const contentType = response.headers?.['content-type'] || '';
    const isApiRequest = url.includes('/api/') || url.startsWith('/api');

    if (isApiRequest && typeof response.data === 'string' && contentType.includes('text/html')) {
      return Promise.reject(new Error('La API devolvio HTML. Verifica REACT_APP_API_URL en el build del frontend.'));
    }

    return response;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
